import { BiTargetLock } from "react-icons/bi";
import { BsPersonBoundingBox } from "react-icons/bs";
import { FaMicrophone, FaRegCalendar } from "react-icons/fa";
import { IoIosPaper } from "react-icons/io";
import { TbTriangleSquareCircleFilled } from "react-icons/tb";

export const menuItems = [
  {
    id: "objetivos",
    icon: <BiTargetLock />,
    title: "Objetivos",
  },
  {
    id: "briefing",
    icon: <IoIosPaper />,
    title: "Empresa",
  },
  {
    id: "persona",
    icon: <BsPersonBoundingBox />,
    title: "Persona",
  },
  {
    id: "tom-e-voz",
    icon: <FaMicrophone />,
    title: "Tom e Voz",
  },
  {
    id: "editorial",
    icon: <TbTriangleSquareCircleFilled />,
    title: "Editorial",
  },
  {
    id: "calendario",
    icon: <FaRegCalendar />,
    title: "Mapa de Criação",
  },
];
